var headerSearchForm = $('.header-search-form');

if(headerSearchForm.length > 0) {
	var headerSearchCtaSearchIcon = $('.header-search-cta-search-icon');
	var headerSearchFormClose = $('.header-search-form-close');
	var headerSearchSubmit = $('.search-submit');
	var searchField = $('.search-field');

	headerSearchCtaSearchIcon.click(function() {
    headerSearchForm.slideDown('fast');
		$('.search-field').focus();
	});

	headerSearchFormClose.click(function() {
    headerSearchForm.slideUp('fast');
	});

	headerSearchSubmit.click(function() {
		var searchQuery = searchField.val();
		var searchQuery1 = searchQuery.replace("’", "'");
		var sanitized = searchQuery1.replace(/[~`!@&]/g, '');
		var exploded = sanitized.split(' ');
		var unamesVals = unique(exploded);
		var joined = unamesVals.join(" ");
		const url = '/?s='+joined.split(" ",9).join(" ")+'';
		window.location.href = url;
	});

	searchField.keyup(function (e) {
    if (e.which == 13) {
			var searchQuery = searchField.val();
			var searchQuery1 = searchQuery.replace("’", "'");
			var sanitized = searchQuery1.replace(/[~`!@&]/g, '');
			var exploded = sanitized.split(' ');
			var unamesVals = unique(exploded);
			var joined = unamesVals.join(" ");
			const url = '/?s='+joined.split(" ",9).join(" ")+'';
			window.location.href = url;
    }
 });

}

function unique(list) {
	var result = [];
	list.forEach(function(e) {
		if (result.findIndex(function(r) {
			return r.toLowerCase() === e.toLowerCase();
		}) === -1)

	result.push(e);
 });

 return result;
}
